import React, { useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Form from "react-bootstrap/Form";
import Card from "react-bootstrap/Card";
import FileCopyIcon from "@mui/icons-material/FileCopy";
import ClearIcon from "@mui/icons-material/Clear";
import { useDropzone } from "react-dropzone";
import { paymentmethod } from "../../../../constants/jsonConstant";
import { images } from "../../../../constants";
import { publishImage } from "../../../../helpers/imageupload";
import { getAsset } from "../../../../helpers/helper";
import {
  useUploadAdPaymentMutation,
  useSubmitAdMutation,
} from "../../../../features/ads/adsApiSlice";
import { SuccessNotify, FailedNotify } from "../../../../constants/tostify";
import "./style.css";

function OrderSumary({ isOpenone, SetisOpenone, adId, budget, onComplete }) {
  const [uploadPayment, { isLoading: isUploading }] = useUploadAdPaymentMutation();
  const [submitAd, { isLoading: isSubmitting }] = useSubmitAdMutation();

  const [displayimg, setDisplayimg] = useState([]);

  const onDrop = async (acceptedFiles) => {
    try {
      const uploadedImages = await publishImage(acceptedFiles);
      setDisplayimg(uploadedImages);
    } catch (error) {
      console.error("Upload error:", error);
      FailedNotify(error.message || "Failed to upload image! Try Again");
    }
  };

  const { getRootProps, getInputProps } = useDropzone({
    accept: "image/*",
    onDrop,
  });

  const removeImage = (index) => {
    const updatedImages = [...displayimg];
    updatedImages.splice(index, 1);
    setDisplayimg(updatedImages);
  };

  const handleCopy = (text) => {
    navigator.clipboard
      .writeText(text)
      .then(() => {
        SuccessNotify("Text copied to clipboard!");
      })
      .catch((err) => {
        console.error("Failed to copy:", err);
      });
  };

  const handlePost = async (e) => {
    e.preventDefault();

    const hasScreenshots = displayimg?.length > 0 && displayimg.some((item) => item);
    if (!hasScreenshots) {
      FailedNotify("Please attach a payment screenshot before proceeding.");
      return;
    }

    try {
      // 1. Upload simulated payment data
      await uploadPayment({
        adId,
        paymentData: {
          method: "Bank Transfer",
          amount: budget,
          screenshot: displayimg[0],
        },
      }).unwrap();

      SuccessNotify("Payment successful! Ad submitted for review.");

      if (onComplete) {
        onComplete();
      } else {
        SetisOpenone(false);
      }
    } catch (error) {
      console.error("Payment submission error:", error);
      const errorMessage = error?.data?.message || error?.message || "Payment failed. Please try again.";
      FailedNotify(errorMessage);
    }
  };

  const isLoading = isUploading || isSubmitting;
  const tax = budget ? (budget * 0.05).toFixed(2) : 0; // 5% simulated tax
  const total = budget ? (parseFloat(budget) + parseFloat(tax)).toFixed(2) : 0;

  return (
    <Container>
      <Modal
        size="xl"
        show={isOpenone}
        onHide={() => SetisOpenone(false)}
        aria-labelledby="example-modal-sizes-title-lg"
        centered
      >
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body className="p-sm-5">
          <Row className="justify-content-center">
            <Col xl={10} md={12} lg={12} sm={12} className="text-center">
              <Modal.Title id="contained-modal-title-vcenter" className="pb-4">
                Payment Details (Total: USD {total})
              </Modal.Title>
              <Row>
                {paymentmethod?.map((e, index) => (
                  <Col lg="4" key={index}>
                    <Form.Group
                      className="mb-3 text-start"
                      controlId={`payment-method-${index}`}
                    >
                      <Form.Label>{e.label}</Form.Label>
                      <div className="d-flex">
                        <Form.Control
                          type="text"
                          value={e.labelvalue}
                          aria-label="Disabled input example"
                          disabled
                          readOnly
                        />
                        <FileCopyIcon
                          fontSize="small"
                          className="cursor_P mt-2 ms-1"
                          onClick={() => handleCopy(e.labelvalue)}
                        />
                      </div>
                    </Form.Group>
                  </Col>
                ))}
              </Row>

              <Row className="text-start mt-3">
                <h5>Instructions:</h5>
                <ul>
                  <li>
                    <p className="font_13 mb-0">
                      Send Payment according to your ad budget including tax (Total: ${total}).
                    </p>
                  </li>
                  <li>
                    <p className="font_13 mb-0">
                      Payment Screen Short must be attached.
                    </p>
                  </li>
                </ul>
              </Row>

              <Row className="text-start mt-3">
                <Col lg="8">
                  <h6>Attach Screen Short:</h6>
                  <Row>
                    <Col lg="9" className="me-auto">
                      <Row>
                        <Col lg={3} className="mt-2 ms-1">
                          <Card
                            style={{ width: "6rem", height: "6rem" }}
                            {...getRootProps()}
                            className="dropzone cursor_P"
                          >
                            <Card.Img
                              className="imet-fit"
                              src={images.AddImage}
                            />
                            <Card.Body>
                              <input
                                type="file"
                                id="file"
                                style={{ display: "none" }}
                                {...getInputProps()}
                                multiple
                              />
                            </Card.Body>
                          </Card>
                        </Col>
                        {displayimg?.length > 0 && (
                          <Col lg={7} className=" mt-1 d-flex">
                            {displayimg.map((image, index) => (
                              <Card
                                key={index}
                                className="me-2 mt-1 position-relative"
                                style={{
                                  width: "6rem",
                                  height: "6rem",
                                  border: "2px solid",
                                }}
                              >
                                <Card.Img
                                  className="imet-fit upload-img mt-0 w-100 h-100"
                                  src={getAsset(image)}
                                  loading="lazy"
                                  alt=""
                                  crossOrigin="anonymous"
                                />
                                <div
                                  className="close-btnone text-white position-absolute top-0 end-0 bg-dark rounded-circle cursor_P"
                                  style={{ transform: "translate(50%, -50%)", padding: "2px" }}
                                  onClick={() => removeImage(index)}
                                >
                                  <ClearIcon fontSize="small" />
                                </div>
                              </Card>
                            ))}
                          </Col>
                        )}
                      </Row>
                    </Col>
                  </Row>
                </Col>

                <Col
                  lg="4"
                  className="d-flex justify-content-end align-items-end"
                >
                  <Button
                    className="cursor_P ps-3 pe-3"
                    onClick={(e) => handlePost(e)}
                    disabled={isLoading}
                  >
                    {isLoading ? "Processing..." : "Proceed"}
                  </Button>
                </Col>
              </Row>
            </Col>
          </Row>
        </Modal.Body>
      </Modal>
    </Container>
  );
}

export default OrderSumary;
